import api from './axios';

export const fetchSalonLogs = (params) => api.get('/logs', { params }).then((r) => r.data);

export const fetchLogActions = () => api.get('/logs/actions').then((r) => r.data);

export const fetchLogStaffOptions = () => api.get('/logs/staff-options').then((r) => r.data);
